function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = {
  "class": "tw-mb-10px"
};
var _hoisted_3 = {
  "class": "tw-mb-10px"
};
var _hoisted_4 = {
  "class": "tw-mb-10px"
};
var _hoisted_5 = {
  "class": "tw-mb-10px"
};
var _hoisted_6 = {
  "class": "form-group tw-mt-20px tw-mb-30px tw-text-12"
};
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: "e avverr\xE0 il reindirizzamento al sito di pvp.giustizia.it"
}, null, -1 /* HOISTED */);
var _hoisted_11 = {
  key: 1,
  id: "keeper-manager-section",
  "class": "tw-mt-20px tw-mb-[80px]"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: "Prenota una visita"
}, null, -1 /* HOISTED */);
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import { computed, ref } from "vue";
import { useValidator } from "@wkComposables/useValidator";
import { useVuelidate } from "@vuelidate/core";
import { alpha, email, numeric, required } from "@vuelidate/validators";
import { replaceAllTokens } from "@utils/StringUtils";
import { sendGAEvent } from "@utils/GaEvents";
import CustodianSupervisorCard from "@vueEntry/CustodianSupervisorCard.vue";
import { sendAgencyContactNoEmailAsync } from "@services/agencyAPI";
import { useMetadataStore } from "@wkWebSrc/js/store";
import md5 from "blueimp-md5";
export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionBookVisitBanner',
  props: {
    labels: {},
    guardian: {},
    supervisor: {},
    isModal: {
      type: Boolean
    },
    referenceId: {},
    agencyId: {},
    pvpLink: {},
    realEstateId: {},
    placeId: {},
    productPrice: {},
    typologyName: {},
    isExtraConsultantActive: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var _this = this;
    var props = __props;
    var pvpRedirectIsLoading = ref(false);
    var mdStore = useMetadataStore();
    var requestData = ref({
      name: "",
      surname: "",
      email: "",
      phone: ""
    });
    var v$ = useVuelidate({
      requestData: {
        name: {
          required: required,
          alpha: alpha
        },
        surname: {
          required: required,
          alpha: alpha
        },
        email: {
          required: required,
          email: email
        },
        phone: {
          required: required,
          numeric: numeric
        }
      }
    }, {
      requestData: requestData
    });
    var _useValidator = useValidator(),
      isValid = _useValidator.isValid;
    var redirectToPvp = function redirectToPvp() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isFormValid, contacts, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return v$.value.$validate();
            case 2:
              isFormValid = _context.sent;
              if (isFormValid) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              pvpRedirectIsLoading.value = true;
              contacts = {
                name: requestData.value.name,
                surname: requestData.value.surname,
                email: requestData.value.email,
                phone: requestData.value.phone,
                notes: "Ho visto questo annuncio all'asta su Wikicasa e vorrei maggiori informazioni",
                referenceId: props.referenceId,
                agencyId: props.agencyId,
                canonicalURL: window._canonicalURL,
                marketingConsent: true
              };
              sendGAEvent("send_form_to_pvp", {
                event_location: mdStore.pageName,
                user_name: requestData.value.name,
                user_surname: requestData.value.surname,
                user_email_hashed: md5(requestData.value.email),
                user_email: requestData.value.email,
                user_phone: requestData.value.phone
              });
              _context.next = 10;
              return sendAgencyContactNoEmailAsync(contacts);
            case 10:
              res = _context.sent;
              if (res) pvpRedirectIsLoading.value = false;
              // eslint-disable-next-line max-len
              window.open("https://pvp.giustizia.it/pvp/it/".concat(props.pvpLink, "&prenotazione.cognome=").concat(requestData.value.surname, "&prenotazione.nome=").concat(requestData.value.name, "&prenotazione.email=").concat(requestData.value.email, "&prenotazione.confermaEmail=").concat(requestData.value.email, "&prenotazione.telefono=").concat(requestData.value.phone), "_blank");
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    var readAndAcceptedByClicking = computed(function () {
      var placeholder = "{0}";
      var tokens = props.labels.read_and_accepted_by_clicking.split(placeholder);
      return "".concat(tokens[0], " <span class=\"tw-font-semibold tw-lowercase\">").concat(replaceAllTokens(placeholder, {
        "{0}": props.labels.title
      }), "</span>").concat(tokens[1]);
    });
    var privacy_C_section = computed(function () {
      return "".concat(props.labels.purpose, " C");
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: "container-auction-book-visit",
        "class": _normalizeClass(_ctx.isModal ? '' : 'tw-mb-20px tw-p-20px tw-bg-w-cultured tw-border-[1px] tw-rounded')
      }, [!_ctx.isModal ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        "class": "tw-text-18 tw-mb-20px",
        innerHTML: _ctx.labels.title
      }, null, 8 /* PROPS */, _hoisted_1)) : _createCommentVNode("v-if", true), _createCommentVNode(" NAME "), _createElementVNode("div", _hoisted_2, [_createVNode(BaseInput, {
        modelValue: requestData.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return requestData.value.name = $event;
        }),
        "data-cy": "name-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.name),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_name
        },
        type: "name",
        name: "name",
        "label-text": _ctx.labels.name
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" SURNAME "), _createElementVNode("div", _hoisted_3, [_createVNode(BaseInput, {
        modelValue: requestData.value.surname,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return requestData.value.surname = $event;
        }),
        "data-cy": "surname-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.surname),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_surname
        },
        type: "surname",
        name: "surname",
        "label-text": _ctx.labels.surname
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" EMAIL "), _createElementVNode("div", _hoisted_4, [_createVNode(BaseInput, {
        modelValue: requestData.value.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return requestData.value.email = $event;
        }),
        "data-cy": "email-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.email),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_mail
        },
        type: "email",
        name: "email",
        "label-text": _ctx.labels.email
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" PHONE "), _createElementVNode("div", _hoisted_5, [_createVNode(BaseInput, {
        modelValue: requestData.value.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return requestData.value.phone = $event;
        }),
        "data-cy": "phone-input",
        "is-valid": _unref(isValid)(_unref(v$).requestData.phone),
        required: "true",
        feedback: {
          valid: '',
          invalid: _ctx.labels.insert_valid_phone
        },
        type: "phone",
        name: "phone",
        "label-text": _ctx.labels.phone
      }, null, 8 /* PROPS */, ["modelValue", "is-valid", "feedback", "label-text"])]), _createCommentVNode(" PRIVACY "), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
        innerHTML: readAndAcceptedByClicking.value
      }, null, 8 /* PROPS */, _hoisted_7), _createElementVNode("span", {
        innerHTML: _ctx.labels.privacy_policy
      }, null, 8 /* PROPS */, _hoisted_8), _createTextVNode(" ("), _createElementVNode("a", {
        "class": "tw-underline-offset-1",
        href: "#",
        onclick: "(function(e){e.preventDefault(); window.open('/privacy','_blank', 'scrollbars=yes, width=550, height=600'); })(event)",
        innerHTML: privacy_C_section.value
      }, null, 8 /* PROPS */, _hoisted_9), _createTextVNode(") "), _hoisted_10]), _ctx.isModal ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_ctx.guardian ? (_openBlock(), _createBlock(CustodianSupervisorCard, {
        key: 0,
        id: "container-auction-custodian-modal",
        "is-phone-showed": !_ctx.supervisor && !_ctx.isExtraConsultantActive,
        "agency-item": _ctx.guardian,
        "real-estate-id": _ctx.realEstateId,
        "place-id": _ctx.placeId,
        price: _ctx.productPrice,
        "typology-name": _ctx.typologyName,
        labels: {
          title: _ctx.labels.guardian,
          phone: _ctx.labels.phone
        }
      }, null, 8 /* PROPS */, ["is-phone-showed", "agency-item", "real-estate-id", "place-id", "price", "typology-name", "labels"])) : _createCommentVNode("v-if", true), _ctx.supervisor ? (_openBlock(), _createBlock(CustodianSupervisorCard, {
        key: 1,
        id: "container-auction-custodian-modal",
        "is-phone-showed": !_ctx.isExtraConsultantActive,
        "agency-item": _ctx.supervisor,
        "real-estate-id": _ctx.realEstateId,
        "place-id": _ctx.placeId,
        price: _ctx.productPrice,
        "typology-name": _ctx.typologyName,
        labels: {
          title: _ctx.labels.supervisor,
          phone: _ctx.labels.phone
        }
      }, null, 8 /* PROPS */, ["is-phone-showed", "agency-item", "real-estate-id", "place-id", "price", "typology-name", "labels"])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createVNode(BaseButton, {
        id: "auction-btn-book-visit",
        "data-cy": "auction-btn-book-visit",
        "btn-class": "tw-btn tw-btn-w-primary tw-btn-sm tw-text-center tw-w-full",
        "is-loading": pvpRedirectIsLoading.value,
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return redirectToPvp();
        })
      }, {
        "default": _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-loading"])], 2 /* CLASS */);
    };
  }
});